/**
 * @generated SignedSource<<ed620a8da1457ce1e1918bd20c68212b>>
 * @relayHash 2103c53d735f991e490d064c47f4e477
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID be855f802987ae713ce771a2def749f914ce00b7a493b56b29d8bc0d4b823c39

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery$variables = {
  accountIds?: ReadonlyArray<string> | null | undefined;
  contentIds: ReadonlyArray<string>;
  endTime?: string | null | undefined;
  startTime: string;
};
export type useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery$data = {
  readonly contentAnalyticsLastViewedAtByPage: {
    readonly nodes: ReadonlyArray<{
      readonly contentId: string;
      readonly lastViewedAt: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery = {
  response: useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery$data;
  variables: useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endTime"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startTime"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountIds",
        "variableName": "accountIds"
      },
      {
        "kind": "Variable",
        "name": "contentIds",
        "variableName": "contentIds"
      },
      {
        "kind": "Variable",
        "name": "endTime",
        "variableName": "endTime"
      },
      {
        "kind": "Variable",
        "name": "startTime",
        "variableName": "startTime"
      }
    ],
    "concreteType": "ContentAnalyticsLastViewedAtByPage",
    "kind": "LinkedField",
    "name": "contentAnalyticsLastViewedAtByPage",
    "plural": false,
    "selections": [
      {
        "concreteType": "ContentAnalyticsLastViewedAtByPageItem",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "contentId"
          },
          {
            "kind": "ScalarField",
            "name": "lastViewedAt"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "2103c53d735f991e490d064c47f4e477",
    "id": "be855f802987ae713ce771a2def749f914ce00b7a493b56b29d8bc0d4b823c39",
    "metadata": {},
    "name": "useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery",
    "operationKind": "query",
    "text": "query useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery($contentIds:[ID!]!,$startTime:String!,$endTime:String,$accountIds:[ID!]){contentAnalyticsLastViewedAtByPage(contentIds:$contentIds,startTime:$startTime,endTime:$endTime,accountIds:$accountIds){nodes{contentId,lastViewedAt}}}"
  }
};
})();

(node as any).hash = "38710c79bd60dde8a74c9adbe1cc64cc";

export default node;
